/**
 * Teams integration configuration, read lazily from Vite env vars.
 *
 * Mirrors `lib/embed/config.ts`: a build-time flag selects the host shell.
 * Read lazily (via a function, not a module-load constant) so tests can
 * `vi.stubEnv(...)` before each call and get fresh values.
 */

export interface TeamsConfig {
  /** Whether the app runs as a Microsoft Teams static tab. */
  teamsEnabled: boolean;
}

/**
 * Read a Vite env var, treating missing, empty, and unreplaced
 * `DUMMY_<key>` placeholder tokens as "not set" (undefined).
 */
function readEnv(key: string): string | undefined {
  const value = import.meta.env[key];
  if (value === undefined || value === "" || value === `DUMMY_${key}`) {
    return undefined;
  }
  return value;
}

export function getTeamsConfig(): TeamsConfig {
  return {
    teamsEnabled: readEnv("VITE_TEAMS_INTEGRATION") === "true",
  };
}
